<template>
  <b-modal
    :visible="show"
    title="Chuyển sang đơn hàng"
    @show="onShow"
    @hidden="$emit('close')"
    hide-footer
    size="md"
  >
    <p class="mb-3">
      Bạn có chắc muốn chuyển đơn đặt trước
      <strong>{{ preorder && preorder.id }}</strong> sang đơn hàng?
    </p>

    <b-form>
      <b-form-group label="Nguồn đơn hàng" label-for="convert-orderSourceId">
        <Treeselect
          id="convert-orderSourceId"
          :value="form.orderSourceId"
          :load-options="loadOptionOrderSources"
          :options="optionOrderSources"
          :auto-load-root-options="false"
          :multiple="false"
          placeholder="Nhập nguồn đơn hàng"
          retryText="Thử lại..."
          loadingText="Đang tải..."
          noResultsText="Không có kết quả"
          :match-keys="['label']"
          openDirection="bottom"
          @input="form.orderSourceId = $event"
        />
      </b-form-group>
    </b-form>

    <div class="d-flex justify-content-end mt-3">
      <b-button variant="secondary" @click="$emit('close')">Hủy</b-button>
      <b-button
        variant="primary"
        class="ml-2"
        :disabled="convertLoading"
        @click="onConfirm"
      >
        <b-spinner v-if="convertLoading" small class="mr-1"></b-spinner>
        Xác nhận
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';

export default {
  name: 'ConvertPreorderModal',
  mixins: [apiCommonMixin],
  components: {
    Treeselect,
  },
  props: {
    show: { type: Boolean, default: false },
    preorder: { type: Object, default: null },
    convertLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      form: {
        orderSourceId: null,
      },
      optionOrderSources: null,
    };
  },
  watch: {
    show(v) {
      if (!v) this.form.orderSourceId = null;
    },
  },
  methods: {
    onShow() {
      this.optionOrderSources = null;
    },
    async loadOptionOrderSources() {
      try {
        const result = await this.fetchOrderSources();
        const raw = result?.data ?? result;
        const list = Array.isArray(raw) ? raw : raw && raw.data ? raw.data : [];
        this.optionOrderSources = list.map((el) => ({
          id: el.id,
          label: el.name || el.id,
        }));
      } catch (e) {
        console.error('Load order sources failed', e);
        this.optionOrderSources = [];
      }
    },
    onConfirm() {
      const payload = {
        orderSourceId: this.form.orderSourceId
          ? Number(this.form.orderSourceId)
          : undefined,
      };
      this.$emit('confirm', payload);
    },
  },
};
</script>
